import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Cacheable } from 'ngx-cacheable';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from './../../../environments/environment.dev';
import { Market } from './../model/market.interface';

@Injectable({
  providedIn: 'root'
})
export class MarketProxy {
  constructor (private http: HttpClient) { }

  @Cacheable({
    shouldCacheDecider: (response: Market[]) => response.length > 0
  })
  public getMarkets(): Observable<Market[]> {
    const headers = new HttpHeaders({
      'x-api-key': '0iMOCyAweJ5v46Xk0SWJY6Zu8W8HUxSkargnoJeW'
    });
    return this.http
      .request<Market[]>('GET', `${environment.theraptorURL}`, { headers })
      .pipe(map((resp: any) => resp.mappings));
  }
}
